import { ActionBase } from '../../../core/store/action/ActionBase';

export const ENABLE_ACCOUNT = '[Customer] User Enable Account';

export class EnableAccountAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ENABLE_ACCOUNT;

  constructor(public payload: { user: { key: string, identifier: string } }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/EnableAccountAction.ts